import { styled } from "styled-components";

import { radius, colorCSS, fontSizes, minWidth } from "../../../styles";
import { redundantCssFromKebab } from "../../../styles/redundant-css";

//todo use colorCSSforSVG here when merged
export const SearchInput = styled.input`
    ${redundantCssFromKebab("border-radius", `${radius.button}`)}
    ${redundantCssFromKebab("border", `1px solid ${colorCSS("N100")}`)}
    ${redundantCssFromKebab("color", `${colorCSS("N300")}`)}
    ${redundantCssFromKebab("display", "block")}
    ${redundantCssFromKebab("font-size", `${fontSizes.sm}`)}
    ${redundantCssFromKebab("margin-bottom", "1.5rem")}
    ${redundantCssFromKebab("padding", "0.5rem 1rem 0.5rem 0.75rem")}
    ${redundantCssFromKebab("width", "100%")}
    &[type="search"] {
        ${redundantCssFromKebab("appearance", "none")}
    }
    &:focus {
        ${redundantCssFromKebab("outline", "none")}
        ${redundantCssFromKebab("box-shadow", `0 0 0 2px ${colorCSS("N900")}`)}
    }
    &:placeholder-shown {
        ${redundantCssFromKebab(
            "background-image",
            'url(\'data:image/svg+xml,%3Csvg width="20" height="20" viewBox="0 0 24 24" fill="%23aaa" xmlns="http://www.w3.org/2000/svg" %3E%3Cpath fillRule="evenodd" clipRule="evenodd" d="M16.436 15.085L20.376 19.095C20.5525 19.2858 20.6478 19.5378 20.6417 19.7976C20.6356 20.0575 20.5286 20.3047 20.3433 20.487C20.158 20.6693 19.9091 20.7722 19.6492 20.7741C19.3893 20.776 19.1389 20.6766 18.951 20.497L15.013 16.491C13.4935 17.6357 11.5959 18.1602 9.70428 17.9583C7.81266 17.7564 6.06845 16.8432 4.82482 15.4036C3.58118 13.9641 2.93106 12.1057 3.00608 10.2048C3.08111 8.30394 3.87568 6.5026 5.22891 5.16554C6.58214 3.82848 8.3929 3.05561 10.2945 3.00343C12.1962 2.95126 14.0466 3.62367 15.4711 4.88451C16.8956 6.14536 17.7878 7.90042 17.9669 9.79432C18.1461 11.6882 17.5988 13.5794 16.436 15.085ZM10.5 16C11.9587 16 13.3576 15.4206 14.3891 14.3891C15.4205 13.3577 16 11.9587 16 10.5C16 9.04134 15.4205 7.64239 14.3891 6.61094C13.3576 5.57949 11.9587 5.00003 10.5 5.00003C9.04131 5.00003 7.64236 5.57949 6.61091 6.61094C5.57946 7.64239 5 9.04134 5 10.5C5 11.9587 5.57946 13.3577 6.61091 14.3891C7.64236 15.4206 9.04131 16 10.5 16Z" /%3E%3C/svg%3E\')'
        )}
        ${redundantCssFromKebab("background-repeat", "no-repeat")}
        ${redundantCssFromKebab("background-position", "right 0.5rem center")}
    }
    &::-webkit-search-cancel-button {
        ${redundantCssFromKebab("background-image", "url(data:image/png)")}
        ${redundantCssFromKebab("background-repeat", "no-repeat")}
        ${redundantCssFromKebab("background-size", "1rem")}
        ${redundantCssFromKebab("display", "block")}
        ${redundantCssFromKebab("height", "1rem")}
        ${redundantCssFromKebab("width", "1rem")}
    }
`;

export const MenuInner = styled.div`
    ${redundantCssFromKebab("padding", "0.5rem 1rem")}
    @media ${minWidth.lg} {
        ${redundantCssFromKebab("padding", "0")}
    }
`;

export const FilterByHeading = styled.p`
    ${redundantCssFromKebab("color", `${colorCSS("N300")}`)}
    ${redundantCssFromKebab("font-size", `${fontSizes.sm}`)}
    ${redundantCssFromKebab("margin-bottom", "0.5rem")}
`;

export const CtaText = styled.div`
    ${redundantCssFromKebab("font-size", `${fontSizes.xxs}`)}
    ${redundantCssFromKebab("padding", "1rem 0 1rem 0.5rem")}

    p {
        ${redundantCssFromKebab("margin", "0")}

        & + p {
            ${redundantCssFromKebab("padding-top", "0.5rem")}
        }
    }
`;

export const CategoryList = styled.ul`
    ${redundantCssFromKebab("font-size", `${fontSizes.sm}`)}
    ${redundantCssFromKebab("list-style", "none")}
    ${redundantCssFromKebab("padding", "0")}
`;

export const CategoryListItem = styled.li`
    ${redundantCssFromKebab("padding", "0.25rem 0")}
`;

export const CategoryListItemLink = styled.a`
    ${redundantCssFromKebab("color", `${colorCSS("N800")}`)}
    ${redundantCssFromKebab("display", "block")}
    ${redundantCssFromKebab("font-weight", "500")}
    ${redundantCssFromKebab("padding", "0.5rem")}
    ${redundantCssFromKebab("text-decoration", "none")}
    /* https://caniuse.com/webkit-user-drag */
    ${redundantCssFromKebab("-webkit-user-drag", "none")}
    ${redundantCssFromKebab("user-select", "none")}
    ${redundantCssFromKebab("width", "100%")}

    &:hover {
        ${redundantCssFromKebab("background-color", `${colorCSS("P50")}`)}
        ${redundantCssFromKebab("transition", "background-color 0.3s ease")}
        ${redundantCssFromKebab("border-radius", `${radius.button}`)}
        ${redundantCssFromKebab("color", `${colorCSS("P500")}`)}
    }

    &.active,
    &:focus:focus-visible {
        ${redundantCssFromKebab("background-color", `${colorCSS("P50")}`)}
        ${redundantCssFromKebab("border-radius", `${radius.button}`)}
        ${redundantCssFromKebab("color", `${colorCSS("P500")}`)}
    }
`;
